import fuzzysort from 'fuzzysort';

/**
 * Error thrown when search fails.
 * @class RSOSSearchError
 */
class RSOSSearchError extends Error {
  constructor(message) {
    super(message);
    this.name = 'SearchError';
  }
}

/**
 * Search for a term in a set of datasets.
 * @param {string} searchTerm
 * @param {array} datasets
 * @returns
 */
const search = (searchTerm, datasets = []) => {
  if (!Array.isArray(datasets)) {
    throw new RSOSSearchError('Datasets must be an array');
  }

  if (datasets.length === 0) {
    return [];
  }

  const searchable = datasets.reduce(
    (accumulator, dataset) => {
      return {
        data: [...accumulator.data, ...dataset.data],
        keys: [...accumulator.keys, ...dataset.keys],
      };
    },
    {
      data: [],
      keys: [],
    },
  );

  const results = fuzzysort.go(searchTerm, searchable.data, {
    keys: searchable.keys,
  });

  // clean up the results, leave out internal meta from fuzzysort.
  const formatted = results.map(result => {
    return { data: result.obj, score: result.score };
  });

  formatted.total = results.total;

  return formatted;
};

export default search;
